import React, {useState} from 'react'
import {Button, message, Modal} from "antd";
import {deleteDepartment} from "../../services/serviceDepartment";
import config from "../../config";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const DepartmentDelete = ({deptId, updater}) => {

    const [deleteModal, setdeleteModal] = useState(false)
    const [loadings, setLoadings] = useState([])


    const handleDeleteClick = (decision) => {
        if (decision && !config.protectedVariables.departmentId.includes(deptId)) {
            enterLoadingState(setLoadings)
            deleteDepartment(deptId)
                .then(() => {
                    exitLoadingState(setLoadings)
                    setdeleteModal(!deleteModal)
                    updater()
                })
                .catch(() => exitLoadingState(setLoadings))
        } else if (decision && config.protectedVariables.departmentId.includes(deptId)) {
            message.error('Bu işlem yapılamaz')

        } else {
            setdeleteModal(!deleteModal)
        }

    }

    return (
        <React.Fragment>
            <Button type={'link'} danger onClick={() => setdeleteModal(!deleteModal)}>Sil</Button>

            <Modal
                open={deleteModal}
                closable={false}
                title={'Silmek istediğinizden emin misiniz ?'}
                footer={[
                    <Button type={'primary'} danger key={'submitButton'}
                            loading={loadings[0]}
                            onClick={() => handleDeleteClick(true)}>Onayla</Button>,
                    <Button key={'cancelButton'} onClick={() => handleDeleteClick(false)}>Vazgeç</Button>
                ]}
            >

            </Modal>
        </React.Fragment>
    )
}
export default DepartmentDelete